import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  private isLoadingSubject = new BehaviorSubject<boolean>(false);
  private loadingCounter = 0;
  loading$: Observable<boolean> = this.isLoadingSubject.asObservable();

  showLoading(): void {
    this.loadingCounter++;
    this.isLoadingSubject.next(true);
  }

  hideLoading(): void {
    this.loadingCounter--;
    if (this.loadingCounter === 0) {
      this.isLoadingSubject.next(false);
    }
  }
}
